import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/tipoPresupuesto/importer/tipoPresupuestoImporterActions';

export default importerReducers(actions);
